import { formatMoney } from "../../lib/currency";
import { TrendingDown } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function QuantityTiersTable({ tiers, currency = "EUR" }) {
  const { t } = useTranslation();
  if (!tiers || tiers.length === 0) return null;
  const fmt = (n) => (typeof n === "number" ? formatMoney(n, currency) : "—");

  return (
    <div className="tech-card p-5" data-testid="quantity-tiers">
      <div className="flex items-center gap-2 mb-3 text-cyan-300">
        <TrendingDown size={14}/>
        <div className="label-tech">{t("tiersTable.heading")}</div>
      </div>
      <p className="text-xs text-slate-400 mb-4 leading-relaxed">
        {t("tiersTable.body")}
      </p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[10px] uppercase tracking-wider text-slate-500 border-b border-slate-800">
              <th className="py-2 pr-3 font-medium">{t("tiersTable.colQty")}</th>
              <th className="py-2 pr-3 font-medium text-right">{t("tiersTable.colSetup")}</th>
              <th className="py-2 pr-3 font-medium text-right">{t("tiersTable.colCycle")}</th>
              <th className="py-2 pr-3 font-medium text-right">{t("tiersTable.colMaterial")}</th>
              <th className="py-2 pr-3 font-medium text-right">{t("tiersTable.colUnit")}</th>
              <th className="py-2 pr-3 font-medium text-right">{t("tiersTable.colDiscount")}</th>
              <th className="py-2 font-medium text-right">{t("tiersTable.colTotal")}</th>
            </tr>
          </thead>
          <tbody>
            {tiers.map((tier) => {
              const isCurrent = tier.is_current;
              const savings = tier.savings_pct_vs_base ?? 0;
              return (
                <tr
                  key={tier.quantity}
                  className={`border-b border-slate-800/60 font-mono-data ${isCurrent ? "bg-cyan-500/5" : ""}`}
                  data-testid={`tier-${tier.quantity}`}
                >
                  <td className="py-2 pr-3">
                    <span className={isCurrent ? "text-cyan-300 font-bold" : "text-slate-200"}>{tier.quantity} {t("tiersTable.pcs")}</span>
                    {isCurrent && <span className="ml-2 text-[9px] text-cyan-400 label-tech">{t("tiersTable.current")}</span>}
                  </td>
                  <td className="py-2 pr-3 text-right text-slate-400">{fmt(tier.setup_per_piece_eur)}</td>
                  <td className="py-2 pr-3 text-right text-slate-400">{fmt(tier.machine_cycle_per_piece_eur)}</td>
                  <td className="py-2 pr-3 text-right text-slate-400">{fmt(tier.material_per_piece_eur)}</td>
                  <td className={`py-2 pr-3 text-right ${isCurrent ? "text-cyan-300 font-bold" : "text-slate-200"}`}>
                    {fmt(tier.unit_price_eur)}
                  </td>
                  <td className="py-2 pr-3 text-right">
                    {savings === 0 ? (
                      <span className="text-slate-600">—</span>
                    ) : savings > 0 ? (
                      <span className="text-emerald-400 font-bold">−{savings}%</span>
                    ) : (
                      <span className="text-red-400">+{Math.abs(savings)}%</span>
                    )}
                  </td>
                  <td className="py-2 text-right text-slate-500">{fmt(tier.total_eur)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
